// ------------- import external dependencies ------------
import React from "react";

// ------------- import internal dependencies -------------
import { CheckBoxLabel } from "../Forms/input/input.style";

export interface CheckboxProps {
  name: string;
  label: string;
  checked?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  testIdPrefix?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  label,
  checked = false,
  onChange,
  onBlur,
  disabled = false,
  className = "align-items-center ml-auto flex",
  testIdPrefix = "checkbox",
}) => {
  return (
    <div
      className={className}
      data-testid={`toggle-box-${name}`}
    >
      <input
        data-testid={`${testIdPrefix}-${name}`}
        type="checkbox"
        id={name}
        key={name}
        style={{ backgroundColor: "gray" }}
        name={name}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      />
      <CheckBoxLabel>{label}</CheckBoxLabel>
    </div>
  );
};

export default Checkbox;
